export enum PayquickerLink {
  Benefits = 1,
  FAQs,
  Fees,
  Verification,
  Introduction,
  Support
}
